import create from 'zustand';
import { userTypes } from '../utils/constants';
import { persist } from 'zustand/middleware';

const useAuthStore = create(
  persist(
    (set, get) => ({
      loading: false,
      user: false,
      error: false,
      token: false,
      initialize: () => {
        const storedUser = get().user;
        const storedToken = get().token;

        if (storedUser && storedToken) {
          set({
            user: storedUser,
            token: storedToken,
          });
        }
      },
      storeUser: async (user, token) => {
        set((state) => ({
          ...state,
          loading: false,
          error: false,
          user,
          token,
        }));
      },
      deleteUser: async (callback) => {
        set((state) => ({
          loading: false,
          error: false,
          user: false,
          token: false,
        }));
        if (callback) {
          callback();
        }
      },
      isSecurityUser: async () => {
        const user = await get().user;
        return user.type === userTypes.security;
      },
      getUser: async () => {
        const user = await get().user;
        return user;
      },
    }),
    {
      name: 'auth-store',
      getStorage: () => sessionStorage, 
    }
  )
);

useAuthStore.getState().initialize();

export default useAuthStore;
